import { render } from "./OrderExpirationListTable.vue?vue&type=template&id=d23fcc28&scoped=true"
import script from "./OrderExpirationListTable.vue?vue&type=script&lang=js"
export * from "./OrderExpirationListTable.vue?vue&type=script&lang=js"

import "./OrderExpirationListTable.vue?vue&type=style&index=0&id=d23fcc28&scoped=true&lang=scss"
import "./OrderExpirationListTable.vue?vue&type=style&index=1&id=d23fcc28&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d23fcc28"]])

export default __exports__